export default __webpack_public_path__ + "static/media/colorIcon.ed9bc3a2.svg";